import React from 'react';

const Card = ({width, height = null, children, className = '', style = {}, onClick = () => {}}) => (
    <div className={'card ' + className} style={{width, height, ...style}} onClick={onClick}>
        {children}
    </div>
);

export default Card;